import type { ProcessedFarm } from '../../hooks/useFarms.js';
import { formatUptime, formatHashrate } from '../../utils/format.js';
import { TableRowSkeleton } from '../shared/Skeleton.js';

interface FarmTableProps {
  farms: ProcessedFarm[];
  loading: boolean;
  selectedFarmId: number | null;
  onSelectFarm: (farm: ProcessedFarm) => void;
}

export function FarmTable({ farms, loading, selectedFarmId, onSelectFarm }: FarmTableProps) {
  return (
    <div class="table-container">
      <table class="data-table">
        <thead>
          <tr>
            <th>Статус</th>
            <th>Ферма</th>
            <th>Видеокарты</th>
            <th>Время работы</th>
            <th>Решений</th>
            <th>Хэшрейт</th>
            <th>Мощность</th>
          </tr>
        </thead>
        <tbody>
          {loading && farms.length === 0
            ? Array.from({ length: 2 }, (_, i) => <TableRowSkeleton key={i} />)
            : farms.map((farm) => {
                const hr = formatHashrate(farm.hashrate);
                const rowClasses = [
                  'clickable',
                  selectedFarmId === farm.id ? 'active' : '',
                  !farm.isOnline ? 'offline-row' : '',
                ].filter(Boolean).join(' ');

                return (
                  <tr
                    key={farm.id}
                    class={rowClasses}
                    onClick={() => onSelectFarm(farm)}
                  >
                    <td>
                      <div class="farm-status">
                        <span class={`status-dot ${farm.isOnline ? 'online' : 'offline'}`} />
                        <span>{farm.isOnline ? 'Online' : 'Offline'}</span>
                      </div>
                    </td>
                    <td class="farm-name">{farm.name}</td>
                    <td>
                      <div class="gpu-indicators">
                        {farm.gpus.map((gpu, i) => (
                          <span
                            key={i}
                            class={`gpu-indicator ${farm.isOnline ? gpu.brand : 'offline'}`}
                            title={gpu.name}
                          />
                        ))}
                      </div>
                    </td>
                    <td>{farm.isOnline ? formatUptime(farm.uptime) : '—'}</td>
                    <td>{farm.isOnline ? farm.solutions.toLocaleString() : '—'}</td>
                    <td>
                      {farm.isOnline && farm.hashrate > 0
                        ? `${hr.value} ${hr.unit}`
                        : farm.isOnline
                          ? <span class="temp-hot">0 H/s</span>
                          : '—'}
                    </td>
                    <td>
                      {farm.isOnline ? (
                        <span class={farm.power >= 2000 ? 'temp-hot' : farm.power >= 1000 ? 'temp-warm' : ''}>
                          {farm.power} W
                        </span>
                      ) : '—'}
                    </td>
                  </tr>
                );
              })}
        </tbody>
      </table>
    </div>
  );
}
